import { EConstraintType } from '../constants';

export type ImageManagementTaskFilter = {
  id?: string;
  field: string | number;
  operator: string;
  value: any;
  disabled?: boolean;
  path?: number[];
  isDropdown?: boolean;
  constraintType?: EConstraintType;
};

export type ImageManagementTaskFilterGroup = {
  id?: string;
  combinator: string;
  rules: ImageManagementTaskFilterArray;
  disabled?: boolean;
  path?: number[];
  not?: boolean;
};

export type ImageManagementTaskFilterArray = (
  | ImageManagementTaskFilter
  | ImageManagementTaskFilterGroup
)[];

export const isOlderThanRule = (
  rule: ImageManagementTaskFilter | ImageManagementTaskFilterGroup,
): rule is ImageManagementTaskFilter =>
  !('rules' in rule) && rule.constraintType === EConstraintType.OlderThanDays;

export const findOlderThan = (
  rules: ImageManagementTaskFilterArray,
): ImageManagementTaskFilter | undefined => {
  for (const rule of rules) {
    if (isOlderThanRule(rule)) {
      return rule;
    }
    if ('rules' in rule) {
      const found = findOlderThan(rule.rules);
      if (found) {
        return found;
      }
    }
  }
  return undefined;
};

export const stripOlderThan = (
  rules: ImageManagementTaskFilterArray,
): ImageManagementTaskFilterArray =>
  rules
    .filter((r) => !isOlderThanRule(r))
    .map((r) => ('rules' in r ? { ...r, rules: stripOlderThan(r.rules) } : r));
